exports.GlobalVariables = {
  DefaultCompanyId: 6,
  RecieveSituations: {
    inWallet: "00",
    inCharge: "10",
    inNotaryOffice: "20",
    protest: "30",
    partiallyLiquidated: "40",
    fullyLiquidated: "50",
    factoring: "60",
    loaded: "70",
    dealing: "80",
    canceled: "90",
    renegotiated: "99",
    creditRecovery: "01",
    suspended: "71",
    waitingLoaded: "69",
    returnToBank: "91",
  },
  PaySituations: {
    inWallet: "00",
    inCharge: "10",
    inNotaryOffice: "20",
    protest: "30",
    partiallyLiquidated: "40",
    fullyLiquidated: "50",
    factoring: "60",
    loaded: "70",
    dealing: "80",
    canceled: "90",
    renegotiated: "99",
  },

  // 'acesso'.'grupos'
  userGroups: {
    master: 32,
  },

  NfTypeFiles: {
    xml: 0,
    danfe: 1,
    cce: 3,
    returnXml: 4,
  },
  nfe: {
    operations: {
      internal: "1",
      interstate: "2",
      foreign: "3",
    },
    inPersonOperationsTypes: {
      notApplied: "0", //Não se aplica (por exemplo, Nota Fiscal complementar ou de ajuste)
      inPerson: "1", //Presencial
      notInPersonOnInternet: "2", //Não presencial, pela Internet
      notInPersonOnCallCenter: "3", //Não presencial, Teleatendimento
      nfceInOperation: "4", //NFC-e em operação com entrega a domicílio
      onSiteOperationOffPremises: "5", //Operação presencial, fora do estabelecimento
      notInPersonOthers: "9", //Não presencial, outros
    },
    types: {
      entry: "E",
      exit: "S",
    },
    assemblyType: {
      automatic: "V",
      manual: "M",
    },
    // prouser.status
    distatus: {
      inTyping: 1, //Em Digitação
      nfeInTyping: 2, //NFe - Em Digitação
      nfeTransmitted: 3, //NFe - Transmitida
      canceled: 4, //Cancelada
    },
    purpose: {
      normalNfe: "1",
      additionalNfe: "2",
      adjustmentNfe: "3",
      returnOfMerchandise: "4",
    },
    models: {
      NF: "01",
      NFP: "04",
      NFe: "55",
      CFeSAT: "59",
      NFCe: "65",
    },
    status: {
      transmitted: "R",
      inTyping: "D",
      canceled: "C",
      complementary: "T",
      unusable: "I",
    },
  },
  state: {
    external: "99",
  },
  clientContract: {
    active: "A",
    suspended: "S",
    canceled: "C",
  },
  situacaoReceber: {
    carteira: "00",
    cobranca: "10",
    cartorio: "20",
    protestado: "30",
    liquidadoParcialmente: "40",
    liquidadoTotalmente: "50",
    factoring: "60",
    baixado: "70",
    negociando: "80",
    cancelado: "90",
    renegociado: "99",
    recupCredito: "01",
    suspenso: "71",
    aguardandoBaixa: "69",
    devolvidoBanco: "91",
  },
  classeConciliacao: {
    contasReceber: "App\\Models\\Erp2\\Financeiro\\ContaReceber",
    contasPagar: "App\\Models\\Erp2\\Financeiro\\ContaPagar",
  },
  /**
   * CFOPs usados em caso da operação de NF ser interestadual.
   * Entrada: CFOP 2, Saída: CFOP 6
   */
  interstadualCfops: {
    entry: [
      "2101",
      "2102",
      "2111",
      "2113",
      "2116",
      "2117",
      "2118",
      "2120",
      "2121",
      "2122",
      "2124",
      "2125",
      "2126",
      "2128",
      "2151",
      "2152",
      "2153",
      "2154",
      "2201",
      "2202",
      "2203",
      "2204",
      "2205",
      "2206",
      "2207",
      "2208",
      "2209",
      "2251",
      "2252",
      "2253",
      "2254",
      "2255",
      "2256",
      "2257",
      "2301",
      "2302",
      "2303",
      "2304",
      "2305",
      "2306",
      "2351",
      "2352",
      "2353",
      "2354",
      "2355",
      "2356",
      "2401",
      "2403",
      "2406",
      "2407",
      "2408",
      "2409",
      "2410",
      "2411",
      "2414",
      "2415",
      "2501",
      "2503",
      "2504",
      "2505",
      "2506",
      "2551",
      "2552",
      "2553",
      "2554",
      "2555",
      "2556",
      "2557",
      "2603",
      "2651",
      "2652",
      "2653",
      "2658",
      "2659",
      "2660",
      "2661",
      "2662",
      "2663",
      "2664",
      "2901",
      "2902",
      "2903",
      "2904",
      "2905",
      "2906",
      "2907",
      "2908",
      "2909",
      "2910",
      "2911",
      "2912",
      "2913",
      "2914",
      "2915",
      "2916",
      "2917",
      "2918",
      "2919",
      "2920",
      "2921",
      "2922",
      "2923",
      "2924",
      "2925",
      "2931",
      "2932",
      "2933",
      "2934",
      "2949",
    ],
    exit: [
      "6101",
      "6102",
      "6103",
      "6104",
      "6105",
      "6106",
      "6107",
      "6108",
      "6109",
      "6110",
      "6111",
      "6112",
      "6113",
      "6114",
      "6115",
      "6116",
      "6117",
      "6118",
      "6119",
      "6120",
      "6122",
      "6123",
      "6124",
      "6125",
      "6151",
      "6152",
      "6153",
      "6155",
      "6156",
      "6201",
      "6202",
      "6205",
      "6206",
      "6207",
      "6208",
      "6209",
      "6210",
      "6251",
      "6252",
      "6253",
      "6254",
      "6255",
      "6256",
      "6257",
      "6258",
      "6301",
      "6302",
      "6303",
      "6304",
      "6305",
      "6306",
      "6307",
      "6351",
      "6352",
      "6353",
      "6354",
      "6355",
      "6356",
      "6357",
      "6359",
      "6360",
      "6401",
      "6402",
      "6403",
      "6404",
      "6408",
      "6409",
      "6410",
      "6411",
      "6412",
      "6413",
      "6414",
      "6415",
      "6501",
      "6502",
      "6503",
      "6504",
      "6505",
      "6551",
      "6552",
      "6553",
      "6554",
      "6555",
      "6556",
      "6557",
      "6603",
      "6651",
      "6652",
      "6653",
      "6654",
      "6655",
      "6656",
      "6657",
      "6658",
      "6659",
      "6660",
      "6661",
      "6662",
      "6663",
      "6664",
      "6665",
      "6666",
      "6667",
      "6901",
      "6902",
      "6903",
      "6904",
      "6905",
      "6906",
      "6907",
      "6908",
      "6909",
      "6910",
      "6911",
      "6912",
      "6913",
      "6914",
      "6915",
      "6916",
      "6917",
      "6918",
      "6919",
      "6920",
      "6921",
      "6922",
      "6923",
      "6924",
      "6925",
      "6929",
      "6931",
      "6932",
      "6933",
      "6934",
      "6949",
    ],
  },
  saleSituation: {
    newSale: 1,
    toInvoice: 4,
    invoiced: 5,
  },
  countryCodes: {
    brazil: "1058",
  },
  trasportModalities: {
    freteRemetente: {
      label: "Contratação do Frete por conta do Remetente",
      value: "0",
    },
    freteDestinatario: {
      label: "Contratação do Frete por conta do Destinatário",
      value: "1",
    },
    freteTerceiros: {
      label: "Contratação do Frete por conta de Terceiros",
      value: "2",
    },
    proprioRemetente: {
      label: "Transporte Próprio por conta do Remetente",
      value: "3",
    },
    proprioDestinatario: {
      label: "Transporte Próprio por conta do Destinatário",
      value: "4",
    },
    semOcorrencia: {
      label: "Sem Ocorrência de Transporte",
      value: "9",
    },
  },
  taxation: {
    documentType: {
      all: "T",
      invoice: "N",
      taxCoupon: "C",
    },
    recipientType: {
      all: "T",
      normalRegime: "1",
      simpleNational: "3",
    },
  },
  company: {
    taxRegime: {
      simpleNational: "1",
      simpleNationalWithFee: "2",
      normalRegime: "3",
    },
    params: {
      utilizaetiquetaeduplicataliatanf: {
        yes: "SIM",
        no: "NAO",
      },
    },
  },
  contract: {
    modality: {
      separate: "A",
      recurring: "R",
    },
  },
  paymentType: {
    positiveCashConferenca: "S",
    negativeCashConferenca: "N",
  },
  product: {
    icms: {
      situations: {
        others: "900",
      },
    },
  },
  nfeRecipientType: {
    client: "C",
  },
  nfeFinancialType: {
    sale: "Venda",
    note: "Nota",
  },
  nfeSenderType: {
    delivery: "E",
  },
  nfeModel: {
    nfe: "55",
    nfce: "65",
  },
  systemVersions: {
    sender: "57",
    essencial: "58",
    advance: "59",
  },
  screenVideosIds: {
    cadastroCliente: "DA36212188024F4F94B0AFB15DE3EFFD",
    cadastroFornecedor: "68A50C7D7E3C4E0F8DD67E2213611E13",
    cadastroTransportadora: "5030A850ED524A1F9A8BFEAD56ECF1E1",
    cadastroVendedores: "9C8CE95740BA4A6CB82F668DAAB54A73",
    // cadastroColaboradores: "C9AC3CE71A48479D96F5E85EEDE04102", // Zend
    // cadastroFuncoes: "B459AADED73445E8AC9E024CCE4D4D12",  // Zend
    cadastroTiposServicos: "3C1B90B81C42459CA1ED2A9BB6D8F066",
    cadastroClassificacaoContratos: "8B47DD8D8BCD4F73B1616AB638E82C7B",
    cadastroMotivoCancelamento: "8942EFEA357B4CF0912C77843DEC21FD",
    cadastroDespesasReembolsaveis: "EA06479DA7CD4A6D91E3F4080C7C6B2F",
    cadastroGeradorContratos: "75BE21AE28A34A798CEAC4AAF6D03A9F",
    // cadastroTipoPagamento: "D4477619ADBE43E3917CD3C140EC5399", // Zend
    // cadastroFormaPagamento: "0CD7802AC40E422E8852C6161B2FC86E", // Zend
    // cadastroPlanoFinanceiro: "8D72A0C5C2554259B43DCF0916C6E53A", // Zend
    controleNfe: "BC12EAA13701487F9AC986E860C0B306",
    nfePainel: "B20DE6F8FAF14A7989A817358B09BBB1",
    // relatorioNfe: "C15EA014DD184046BE6727717020CC81",   // Zend
    gerenciamentoContratoServico: "5226230A46C24DC2B49ED38AFAD414CE",
    faturamentoOneClick: "D165E537559846F0A45B74DBBDDDCAD9",
    relatorioNotaFiscalServico: "AA1978280D1D4437BF3C22A3E6351905",
    conciliacaoBancaria: "E9958C31FBFD4CA2A46A5945AC55FB4B",
  },
};
